export const STATUS_DISABLED = [1, 2]
